module.exports = __webpack_public_path__ + "img/vertical_4_5_8023.c2587b25.png";